<script>
  // The Map tab (Miles 2026-11-05): one place for the routes. Map = the picture; List = every route per offer and
  // every door (was the Offers tab). Tech Mode lives here too, because it only changes the map.
  import MapView from './MapView.svelte';
  import OffersView from './OffersView.svelte';
  import { ui } from '../lib/stores/ui.svelte.js';

  const KEY = 'bb_map_view';
  let view = $state((() => { try { return localStorage.getItem(KEY) || 'map'; } catch { return 'map'; } })());
  function setView(v) { view = v; try { localStorage.setItem(KEY, v); } catch {} }
</script>

<div class="bar">
  <div class="toggle">
    <button type="button" class:on={view === 'map'} onclick={() => setView('map')}>Map</button>
    <button type="button" class:on={view === 'list'} onclick={() => setView('list')}>List</button>
  </div>
  {#if view === 'map'}
    <button class="tech" class:active={ui.techMode} onclick={() => ui.toggleTechMode()} type="button" title="Toggle Tech Mode">
      Tech Mode <span class="tag">{ui.techMode ? 'On' : 'Off'}</span>
    </button>
  {/if}
</div>

{#if view === 'map'}<MapView />{:else}<OffersView />{/if}

<style>
  .bar { display: flex; align-items: center; gap: 12px; padding: 10px 24px 0; flex-wrap: wrap; }
  .toggle { display: inline-flex; border: 1px solid var(--border); border-radius: 999px; padding: 3px; }
  .toggle button { background: transparent; border: none; color: var(--text-muted); padding: 6px 16px; border-radius: 999px;
    font: inherit; font-size: 13px; font-weight: 600; cursor: pointer; }
  .toggle button.on { background: #d4af37; color: #141216; }
  .tech { display: inline-flex; align-items: center; gap: 6px; padding: 6px 12px 6px 14px; border-radius: 999px;
    background: transparent; border: 1px solid rgba(255,255,255,0.1); color: #9aa0a6; font-family: var(--font-sans);
    font-size: 12px; font-weight: 500; cursor: pointer; }
  .tech.active { background: rgba(212,175,55,0.15); border-color: rgba(212,175,55,0.4); color: #d4af37; }
  .tag { font-family: var(--font-mono); font-size: 9px; font-weight: 700; letter-spacing: 1.2px; text-transform: uppercase;
    background: rgba(255,255,255,0.06); color: #6a6a6e; padding: 2px 6px; border-radius: 999px; }
  .tech.active .tag { background: rgba(212,175,55,0.3); color: #0a0a0c; }
</style>
